import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import {Row, Col} from 'react-bootstrap'
import './VideoComponent.css'

class VideoComponent extends Component {
    constructor(props) {
        /* takes in txt and vidSrc */
        super(props)
        console.log("txt", this.props.txt)
    }

    componentDidUpdate() {
        if (this.props.txt.length > 0) {
            this.refs.videoBottom.scrollIntoView({
                    block: "end", 
                    inline: "nearest", 
                    behavior: "smooth"
                  }
            )
        }
    }
    render() {
        if (this.props.txt.length > 0) {
            
            return (
                <div>
                    <Row >
                        <Col lg={1} md={0}></Col>
                        <Col lg={10} md={12}>
                            <div className="embed-responsive embed-responsive-16by9" ref="video" >
                                <iframe title="vidFrm"
                                    className="embed-responsive-item" 
                                    src={this.props.vidSrc + "?rel=0&showinfo=0"}
                                    allowFullScreen>
                                </iframe>
                            </div>
                        </Col>
                        <Col lg={1} md={0}></Col>
                    </Row>
                    <div ref="videoBottom"></div>
                </div>
            )
        }
        else {
            return (<p></p>)
        }
    }
}
export default VideoComponent


// WEBPACK FOOTER //
// ./src/VideoComponent/VideoComponent.js